import React from 'react'

export default function Receipt() {
  return (
    <div>index</div>
  )
}
